// src/mixins/utilsMixin.js

export const utilsMixin = {
    // Vuex Getter'larını computed property olarak ekliyoruz
    computed: {
        isAdmin() {
            return this.$store.getters['user/isAdmin'];
        },
        isDeveloper() {
            return this.$store.getters['user/isDeveloper'];
        },
        isFenomen() {
            return this.$store.getters['user/isFenomen'];
        },
        isSaleTeam() {
            return this.$store.getters['user/isSaleTeam'];
        },
        userData() {
            return this.$store.getters['user/userData'];
        }
    },

    // Tüm yardımcı metotları methods objesine ekliyoruz
    methods: {
        changeFormat(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        formatDateTime(dateString) {
            if (!dateString) return '-';

            const date = new Date(dateString);
            const formattedTime = date.toLocaleTimeString('tr-TR', {
                hour: '2-digit',
                minute: '2-digit'
            });

            return `${formattedTime}`;
        },
        formatDate(dateString, includeYear = true) {
            const date = new Date(dateString);
            const options = {
                day: '2-digit',
                month: 'long',
            };

            if (includeYear) {
                options.year = 'numeric';
            }

            return new Intl.DateTimeFormat('tr-TR', options).format(date);
        },
        priceFormat(val) {
            const numberVal = parseFloat(val);

            if (isNaN(numberVal)) return val;

            return numberVal.toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + " TL";
        },
        diffDateMonth(year) {
            const nowYear = new Date().getFullYear();
            const start = new Date(year, 0, 1);
            const end = nowYear != year ? new Date(year, 11, 31) : new Date();

            const months = [];
            let current = new Date(start);

            while (current <= end) {
                const monthName = current.toLocaleString('default', {
                    month: 'long'
                });
                months.push(monthName);

                current.setMonth(current.getMonth() + 1);
            }

            return months;
        }
    },
};